export var Products = {
  JIRA: 'jira',
  CONFLUENCE: 'confluence',
  JIRA_PRODUCT_DISCOVERY: 'jira-product-discovery',
  JIRA_SERVICE_MANAGEMENT: 'jira-service-management'
};